export const topupStatus = {
  valid: 'valid',
  invalid: 'invalid',
}
